module.exports = fox._r("images/press/icon-blog-comments.png", __webpack_public_path__ + "_/common/images/press/icon-blog-comments.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-blog-comments.png
// module id = 381
// module chunks = 2